import { render, staticRenderFns } from "./BaseComponentEditorTree.vue?vue&type=template&id=6299f6b2"
import script from "./BaseComponentEditorTree.vue?vue&type=script&lang=js"
export * from "./BaseComponentEditorTree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports